import React, { useState, useEffect } from 'react';
import './Spinner.css';
import budaSpin1 from '../assets/BudaSpin1.png';
import budaSpin2 from '../assets/BudaSpin2.png';

const Spinner = ({ 
  size = 'medium', 
  color = 'gold', 
  className = '',
  fullScreen = false 
}) => {
  const sizeClasses = {
    small: 'spinner-small',
    medium: 'spinner-medium', 
    large: 'spinner-large'
  };

  const colorClasses = {
    gold: 'spinner-gold',
    white: 'spinner-white',
    primary: 'spinner-primary',
    success: 'spinner-success',
    error: 'spinner-error'
  };

  const spinnerClass = `
    spinner-component 
    ${sizeClasses[size] || sizeClasses.medium} 
    ${colorClasses[color] || colorClasses.gold}
    ${className}
  `.trim();

  if (fullScreen) {
    return (
      <div className="spinner-fullscreen">
        <div className={spinnerClass}></div>
      </div>
    );
  }

  return (
    <div className="spinner-inline">
      <div className={spinnerClass}></div>
    </div>
  );
};

// Spinner específico para botones
export const ButtonSpinner = ({ size = 'small', color = 'white' }) => {
  return <Spinner size={size} color={color} className="spinner-button" />;
};

// Spinner global: dos imágenes del buda; cada 3 s el buda "abre el ojo" 0,7 s (BudaSpin2)
export const LoadingSpinner = ({ text }) => {
  const [showWink, setShowWink] = useState(false);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let timeoutId = null;
    const interval = setInterval(() => {
      setShowWink(true);
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setShowWink(false), 700);
    }, 3000);
    return () => {
      clearInterval(interval);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="spinner-fitness-fullscreen" aria-hidden="true">
      <div className="spinner-fitness-content">
        <div className="spinner-fitness-circle-wrap">
          <svg className="spinner-fitness-circle" viewBox="0 0 200 200" aria-hidden="true">
            <defs>
              <linearGradient id="spinner-circle-grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="rgba(255, 215, 0, 0.5)" />
                <stop offset="50%" stopColor="rgba(255, 140, 0, 0.25)" />
                <stop offset="100%" stopColor="rgba(255, 215, 0, 0.5)" />
              </linearGradient>
              <linearGradient id="spinner-circle-grad2" x1="0%" y1="100%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="rgba(56, 189, 248, 0.2)" />
                <stop offset="100%" stopColor="rgba(255, 215, 0, 0.2)" />
              </linearGradient>
              <filter id="spinner-circle-glow">
                <feGaussianBlur stdDeviation="0.8" result="blur" />
                <feMerge>
                  <feMergeNode in="blur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            <circle className="spinner-fitness-ring spinner-fitness-ring-1" cx="100" cy="100" r="94" fill="none" stroke="url(#spinner-circle-grad1)" strokeWidth="0.6" />
            <circle className="spinner-fitness-ring spinner-fitness-ring-2" cx="100" cy="100" r="88" fill="none" stroke="rgba(255, 255, 255, 0.12)" strokeWidth="0.4" />
            <circle className="spinner-fitness-ring spinner-fitness-ring-3" cx="100" cy="100" r="82" fill="none" stroke="url(#spinner-circle-grad2)" strokeWidth="0.5" />
            <circle className="spinner-fitness-ring spinner-fitness-ring-4" cx="100" cy="100" r="76" fill="none" stroke="rgba(255, 215, 0, 0.2)" strokeWidth="0.35" />
            <circle className="spinner-fitness-ring spinner-fitness-ring-5" cx="100" cy="100" r="70" fill="none" stroke="rgba(255, 255, 255, 0.08)" strokeWidth="0.3" />
          </svg>
        </div>
        <div className="spinner-fitness-buda-wrap">
          <img
            src={budaSpin1}
            alt=""
            className={`spinner-fitness-rata-buda ${showWink ? 'spinner-fitness-buda-hidden' : ''}`}
            aria-hidden="true"
          />
          <img
            src={budaSpin2}
            alt=""
            className={`spinner-fitness-rata-buda ${showWink ? '' : 'spinner-fitness-buda-hidden'}`}
            aria-hidden="true"
          />
        </div>
      </div>
      {text && <p className="spinner-fitness-text">{text}</p>}
    </div>
  );
};

// Spinner inline pequeño
export const InlineSpinner = ({ color = 'gold' }) => {
  return <Spinner size="small" color={color} />;
};

export default Spinner;